module.exports = __webpack_public_path__ + "fonts/Roboto-Light.7b5fb88f.ttf";